import { useCallback, useContext, useState } from "react";
import { ScreenStateContext, useScreenState } from "./useScreenState.js";
import { selectedMonth, validMonthKey } from "../lib/monthState.js";

// Save explicit month choices only. With no choice, a fresh entry uses its
// current Korean calendar/payment default, including the 16th-day policy.
export function useMonthState(scope, defaultMonth) {
  const attached = !!useContext(ScreenStateContext);
  const [fallback] = useState(() => typeof defaultMonth === "function" ? defaultMonth() : defaultMonth);
  const [saved, setSaved] = useScreenState(scope, { month: "" },
    (v) => ({ month: validMonthKey(v.month) ? v.month : "" }));
  const [local, setLocal] = useState({ scope, month: "" });
  const setMonth = useCallback((next) => {
    const update = (previous) => {
      const current = selectedMonth(previous, fallback);
      return selectedMonth(typeof next === "function" ? next(current) : next, current);
    };
    if (attached) setSaved((previous) => ({ month: update(previous.month) }));
    else setLocal((previous) => ({ scope, month: update(previous.scope === scope ? previous.month : "") }));
  }, [attached, scope, fallback, setSaved]);
  return [selectedMonth(attached ? saved.month : local.scope === scope ? local.month : "", fallback), setMonth];
}
